import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

import axios from './axios';

export interface UseRefreshTokenVariables {}

export interface UseRefreshTokenData {
  access: string;
  refresh: string;
}

export function useRefreshToken() {
  return useMutation<
    UseRefreshTokenData,
    AxiosError<UseRefreshTokenData>,
    UseRefreshTokenVariables
  >(
    () => {
      const data = { refresh: localStorage.getItem('refresh') };

      return axios
        .post<UseRefreshTokenData>('/posht/ashena/signin/token/refresh/', data)
        .then((res) => res.data);
    },
    {
      onSuccess: (data) => {
        axios.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${data.access}`;
      },
    },
  );
}
